import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { Field, serializeReq, validateForm } from "components/shared/form";
import Loader from "components/shared/loader";
import { bidRefuelingServiceTypesEnum, fuelTankTypes, fuelTankTypesEnum } from "helpers/enums";
import { dieselFuelTank, gasFuelTank } from "helpers/models";
import { connect } from "helpers/redux";
import { enumLabel } from "helpers/system";
import pick from "lodash/pick";
import React, { Component } from "react";
import { alert } from "services/alert";
import { addToPlanQueue } from "sources/books/refueling";
import { getFuelInfoForRefuelPlanning as trailerRefuelPlanning } from "sources/books/trailers";
import { getFuelInfoForRefuelPlanning as truckRefuelPlanning } from "sources/books/trucks";
import { config, initialState } from "./config";

class PlanRefueling extends FormTemplate {
    initialState = {
        showPanel: true,
        isFetching: false,
        isLoading: true,
    };

    isValidForm = (state) => {
        const { config } = this.props;
        return validateForm(config, serializeReq(state));
    };

    setValue = ({ name, value }, i) => {
        const newValue = this.state.fuelTanks.map((fuelTank, index) =>
            index === i ? { ...fuelTank, [name]: value } : fuelTank,
        );
        const isValid = this.isValidForm({ ...this.state, fuelTanks: newValue });
        this.setState({ fuelTanks: newValue, ...(isValid ? { isValid: true } : {}) });
    };

    renderField = (props, i) => {
        if (props.inputProps.disabled) {
            delete props.inputProps.disabled;
        }
        return (
            <Field
                key={props.label}
                wrapper="book-field"
                onChange={(data) => {
                    const newValue = data.value ? parseInt(data.value) : "";
                    this.setValue({ ...data, value: newValue }, i);
                }}
                value={this.state.fuelTanks[i][props.inputProps.name]}
                {...props}
                fieldWrapper="col-4"
                labelWrapper="col-8 col-form-label col-form-label-sm"
                bWrapper="row mb-1"
            />
        );
    };

    saveRefueling = () => {
        this.setState({ isLoading: true });
        const { config, bidId } = this.props;
        const data = pick(this.state, Object.keys(config));
        const stateData = { ...serializeReq(data), bidId };

        addToPlanQueue(stateData).then((res) => {
            if (res) {
                this.close(res);
                alert({ message: "Запущен процесс планирования заправок.", type: "success" });
            } else {
                this.setState({ isLoading: false, isValid: false });
            }
        });
    };

    renderMultiGoFuelTank = (_, index) => {
        const { config } = this.props.config.fuelTanks;
        return (
            <div key={index} className="pb-3">
                <small className="text-muted">
                    <strong>
                        Топливный бак №{index + 1} - {enumLabel(fuelTankTypes, this.state.fuelTanks[index].type)}
                    </strong>
                </small>
                {this.renderField(config.currentVolume, index)}
                {this.renderField(config.fuelConsumption, index)}
            </div>
        );
    };

    renderFuelTank = (_, index) => {
        const { config } = this.props.config.fuelTanks;
        const { relationType } = this.state.fuelTanks[index];
        return (
            <div key={index} className="pb-3">
                <strong>
                    Топливный бак №{index + 1} в {relationType === "Car" ? "машине" : "прицепе"} -{" "}
                    {enumLabel(fuelTankTypes, this.state.fuelTanks[index].type)}
                </strong>
                {this.renderField(
                    {
                        ...config.fuelConsumption,
                        label: relationType === "Car" ? "Расход топлива, л/100км" : "Расход топлива, л/ч",
                    },
                    index,
                )}
                {this.renderField(config.minimumVolume, index)}
                {this.renderField(config.currentVolume, index)}
                {this.renderField(config.totalVolume, index)}
                {this.renderField(config.minimumVolumeInFinishDesired, index)}
            </div>
        );
    };

    renderBody = () => {
        const { isLoading } = this.state;
        if (isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const { carLinked, refuelingServiceType } = this.props;
        const cname = cn("p-2", { "modal-window__form--invalid": !this.state.isValid });
        if (carLinked) {
            return (
                <>
                    <div className={cname}>
                        {refuelingServiceType === bidRefuelingServiceTypesEnum.MultiGo ||
                        refuelingServiceType === bidRefuelingServiceTypesEnum.MultiGo2
                            ? this.state.fuelTanks.map(this.renderMultiGoFuelTank)
                            : this.state.fuelTanks.map(this.renderFuelTank)}
                    </div>
                    {this.renderFormActions()}
                </>
            );
        } else {
            return (
                <div className="alert alert-warning show-bid__without-refueling-wrap">
                    <div className="show-bid__without-refueling-icon--wrapper">
                        <i className="show-bid__without-refueling-icon" />
                    </div>
                    Отключен: расчет топлива
                </div>
            );
        }
    };

    renderFormActions = () => {
        const cname = (mainClass) => cn(mainClass, "btn btn-sm");
        return (
            <div className="map-panels__footer">
                <div className="map-panels__actions">
                    <div className={cname("btn-light")} onClick={() => this.close()}>
                        Отмена
                    </div>
                    <div>
                        <div className={cname("btn-brand ml-1")} onClick={this.saveRefueling}>
                            Запланировать
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

export const withLoadedSettings = (ChildComponent) => {
    class HOComponent extends Component {
        state = {
            isLoaded: false,
            carLinked: false,
        };

        componentDidMount() {
            const { bid, minimumVolumeInFinishDesired } = this.props;
            Promise.all([truckRefuelPlanning(bid.car.carId), trailerRefuelPlanning(bid.trailer?.trailerId)]).then(
                ([carFuelInfo, trailerFuelInfo]) => {
                    if (carFuelInfo || trailerFuelInfo) {
                        const allFuelTanks = [];
                        const initial = { ...initialState };
                        if (carFuelInfo) {
                            const { fuelTanks } = carFuelInfo;
                            if (fuelTanks?.length) {
                                allFuelTanks.push(...fuelTanks);
                                allFuelTanks
                                    .filter((item) => item.type === fuelTankTypesEnum.Diesel)
                                    .forEach((x) => {
                                        x.minimumVolumeInFinishDesired = minimumVolumeInFinishDesired;
                                    });
                            }
                        }
                        if (trailerFuelInfo) {
                            allFuelTanks.push(...(trailerFuelInfo.fuelTanks || []));
                        }
                        if (allFuelTanks.length) {
                            initial.fuelTanks = allFuelTanks;
                        } else {
                            if (this.props.refuelingServiceType === bidRefuelingServiceTypesEnum.MultiGo) {
                                initial.fuelTanks = [dieselFuelTank, gasFuelTank];
                            } else {
                                initial.fuelTanks = [dieselFuelTank];
                            }
                        }
                        this.setState({ initial, isLoaded: true, carLinked: true });
                    } else {
                        this.setState({ carLinked: false, isLoaded: true, initial: initialState });
                    }
                },
            );
        }

        render() {
            if (!this.state.isLoaded) {
                return null;
            }
            return (
                <ChildComponent
                    {...this.props}
                    config={config}
                    carLinked={this.state.carLinked}
                    initialState={this.state.initial}
                />
            );
        }
    }

    return connect((state) => ({
        refuelingServiceType: state.profile.organization.refuelingServiceType,
    }))(HOComponent);
};

export default withLoadedSettings(PlanRefueling);
